export default __webpack_public_path__ + "static/media/help_outline-blue-18dp.49fb0025.svg";